































import {
  Vue,
  Component,
  Watch,
  Prop,
} from "@/shared/vuepack";
import HsabImportedClaimColumns from "@/employee/components/hsabExpenses/HsabImportedClaimColumns.vue";
import HsabImportedClaimRow from "@/employee/components/hsabExpenses/HsabImportedClaimRow.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import { useClaimStore } from "@/employee/store/claim";
import { usePayeeStore } from "@/employer/store/payee";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import claim from "@/shared/resource/claim";
import Button from "@/shared/components/ui/Button.vue";
import HsabExpenseCardColumns from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardColumns.vue";

@Component({
  computed: {
    claim () {
      return claim;
    }
  },
  components: {
    HsabExpenseCardColumns,
    Button,
    HsabImportedClaimColumns,
    HsabImportedClaimRow,
    Paginator
  }
})
export default class TalonClaimsTable extends Vue {
  claimStore = useClaimStore();
  payeeStore = usePayeeStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  mounted () {
    this.loadTalonClaims();
    this.payeeStore.loadPayees();
  }
  loadTalonClaims () {
    this.claimStore.loadClaims({
      pageNumber: this.claimStore.currentPage,
    }).catch(() => null);
  }

  get currentPage () {
    return this.claimStore.currentPage;
  }

  get pageCount () {
    return this.claimStore.pageCount;
  }

  get hasPages () {
    return this.claimStore.pageCount > 0;
  }

  get loaded () {
    return this.claimStore.areClaimsLoaded;
  }
  get items () {
    return this.claimStore.claims;
  }
  get linkAndCreateExpenseFeatureEnabled (): boolean {
    return (
        this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.bend23030ClaimLinkAndCreateFeatureEnabled
    );
  }
  onSwitchPage (pageNumber): void {
    this.claimStore.setPageNumber(pageNumber);
    this.claimStore.loadClaims({ pageNumber });
  }
}
